/*
 * @Author: “Fiona” “fionaandoranges@outlook.com”
 * @Date: 2024-11-05 19:48:44
 * @LastEditors: “Fiona” “fionaandoranges@outlook.com”
 * @LastEditTime: 2024-11-06 14:31:20
 * @FilePath: \shop-web\src\apis\detail.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/http'
const AUTH_BASE_URL = "/api/v1";

//收藏
export const forwardPostageRouteAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/forward_postage_route`,
        method: 'POST',
        data
    })
}